
export const apimSubscriptionKey = "444da0cf60df4c49b11b4ff5d3dfbe50";
export const relativePath = "/healthpatri";
export const whatsappNumber = "918169581695";
export const publicUrl="https://healthhub.jio.com"
export const x_request_checksum_key = "KV1f1S09M9rA4WXf";
export const staticData={
      distanceGoal: {
        entity_id: "64a7efcf526db771d528659f",
        unit_id: "619cfd74f137dfc183156aae"
      },
      stepsGoal: {
        entity_id: "60463fa1f0741fbde46ad52e",
        unit_id: "5ff562512ec3ddfb1af3810e"
      },
      caloriesGoal: {
        entity_id: "60463fb0c6e6fe057d03e58b",
        unit_id: "5fc220546432ac1346256e9d"
      },
      minutes: {
        unit_name: "minutes",
        unit_id: "5ff5628812d04143c8813d47"
      },
      yoga:{
        name: "Yoga & Workout",
        value: "60df31efa9ce3c4025036333"
      },
      goalDuration:{
        unit_id: "64faae454ecb560f2ba55051",
      }
  }
export const BIFROST_DOMAIN_NAME = 'https://bifrost.healthhub.net.in'
export const gaSiteName = "HealthPatri";
export const env = "https://api.prod.health.jio.com/";
export const JHHActualEnv = "https://production.healthhub.net.in/";
export const HPTnCEnv = "https://production.healthhub.net.in/jiohealthhub/healthpatri/tnc";
export const appConfigsCache = "_achp";
export const getConfigVersionKey = "_gcvhp";
export const HFRelativePath = "/healthfeed";
export const jioHealthPlayStoreLink = "https://play.google.com/store/apps/details?id=com.hh.healthhub&referrer=utm_source%3DOrganic%26utm_medium%3DSocial%26utm_term%3DOffer-Share%26utm_campaign%3DInstall%2520by%2520Share%2520Offer%2520";
export const jioHelathAppStoreLink = "https://itunes.apple.com/in/app/jiohealthhub/id1056115951?mt=8";
export const JHHMainEnv = env + "jhh-webapp-main/";
export const JHHPatientAppEnv = env + "jhh-webapp-patient-app/";
export const JHHUploadEnv = env + "jhh-webapp-upload/";
export const JHHCorePlatform = env + "core-platform/";
export const JHHAppIntegrationService = env + "app-integration-service/";
const healthPatriServiceVersion1 =  JHHAppIntegrationService + "v1/health-patri-service/api/";
const appIntegrationServiceVersion1 =  JHHAppIntegrationService + "v1/";//@ts-ignore
export const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
export const isAndroid = navigator.userAgent.match(/Android/i);
export const isiOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
export const fallbackErrorMessage =
  "Something went wrong. Please try again, later!";;

export const getJHHUploadPhoto =  JHHUploadEnv + "user/upload_profile"
export const getJHHPartnerAccessTokenPath = JHHMainEnv + "authenticationservice/v1/getPartnerAccessToken"
export const getJHHRequestTokenPath = JHHMainEnv + "api_authentication/request_token"
export const getJHHRefreshTokenPath = JHHMainEnv + "api_authentication/refresh_token"
export const getJHHRefreshTokenAckPath = JHHMainEnv + "api_authentication/refresh_token_ack"
export const getJHHSendRegistrationOTPPath = JHHMainEnv + "users/send_registration_otp"
export const getJHHResendRegistrationOTPPath = JHHMainEnv + "users/resend_registration_otp"
export const getJHHRequestAccessPath = JHHMainEnv + "v1/users/request_access"
export const getJHHRegisterDevicePath = JHHMainEnv + "users/register_device"
export const getJHHRValidateMPIN = JHHMainEnv + "users/validate_mpin"
export const getJHHWebRequestToken = JHHMainEnv + "api_authentication/validate_token"
export const getJHHWebRequestAccess = JHHMainEnv + "users/web_request_access"
export const getJHHWebRequestTokenV2 = JHHMainEnv + "api_authentication/validate_token_v2"
export const getJHHForgotMpinPath = JHHMainEnv + "users/mpin_update"
export const getJHHForgotMpinVerifyOtpPath = JHHMainEnv + "users/verify_mpin_otp_v2"
export const getJHHForgotMpinResendOtpPath = JHHMainEnv + "users/resend_mpin_otp"
export const getJHHUpdateProfileDetailsPath = JHHMainEnv + "users/update_profile_details"
export const getAllUserDataPath = JHHMainEnv + "users/get_all_user_data";
export const getSwitchProfilePath = JHHMainEnv + "users/get_profile_data";
export const getProfileDetailPath = JHHMainEnv + "users/get_profile_detail";
export const getUsersLinkedByMePath = JHHPatientAppEnv + "profile/v1/user_family/linked_by_me";
export const  getNewFamilyProfilePath = JHHPatientAppEnv + "profile/v1/user_family/create_profile";
export const  getJHHSendFamilyAssociationOTPPath = JHHPatientAppEnv + "profile/v1/user_family/send_otp";
export const  getVerifyAssociationOTPPath = JHHPatientAppEnv + "profile/v1/user_family/verify_otp";
export const  getFamilyMPINVerifyPath = JHHPatientAppEnv + "profile/v1/user_family/family_mpin_verify";
export const  getRelationshipLabels = JHHPatientAppEnv + "profile/v1/user_family/master_relationship";

export const getLocalisationConfig =  JHHCorePlatform + "localisation/get_localisation/?app_id=jhh-mobile-app&language=";
export const getAppConfig =  appIntegrationServiceVersion1 + "core-platform/app_configuration/app_configs";
export const getAppConfigV2 = appIntegrationServiceVersion1 + "core-platform/app_configuration/app_configs_v2";
export const  termsAndConditionsUrl = JHHActualEnv + "jiohealthhub/tnc.html";
export const  jhhMainFaqUrl = JHHActualEnv + "jiohealthhub/faq";
export const getHealthPatriIndexPageData = healthPatriServiceVersion1 + "get_index_page";
export const getHealthPatriIndexSectionData =  healthPatriServiceVersion1 + "section_name/summary";
export const getHealthPatriIndexSectionItemData = healthPatriServiceVersion1 + "section_name/item_id/details";
export const getHealthPatriSectionRecommendations = healthPatriServiceVersion1 + "section_name/get_recommendations";
export const getHealthPatriSymptomsSummary = healthPatriServiceVersion1 + "symptoms/summary";
export const getHealthPatriExpiredReports =  healthPatriServiceVersion1 + "expired_reports";
export const getHealthPatriAllListedCondition =  healthPatriServiceVersion1 + "get_all_listed_condtions";
export const getConfigVersion = JHHActualEnv + "appintegrationservice/v1/core-platform/localisation/get_config";
export const getEntity = appIntegrationServiceVersion1 + "ditto-platform/get_entity/";
export const getHPAggregatedMetricData =  appIntegrationServiceVersion1 + "data-service/aggregated_metric_data";
export const  eventAPI = appIntegrationServiceVersion1 + "uaas-event-publisher-platform/api/event";
export const bulkDeleteDataAPI = appIntegrationServiceVersion1 + "data-service/bulk_delete";
export const rawDeleteDataAPI = appIntegrationServiceVersion1 + "data-service/delete_raw";
export const rawDataAPI = appIntegrationServiceVersion1 + "data-service/raw_data";
export const symptomCheckerUrl = "https://healthhub.jio.com";
export const getHPLatestMetricData =  appIntegrationServiceVersion1 + "data-service/latest_data";
export const getConsent = JHHPatientAppEnv + "profile/v1/user_notification_consents/get_all_consent";
export const setConsent = JHHPatientAppEnv + "profile/v1/user_notification_consents/set_consent";
export const sourceAuthorization = JHHMainEnv + "api_authentication/source_authorization";
export const getUserHPSharedList = JHHPatientAppEnv + "health_patri/v1/my_health_patri/shared_list";
export const getUserHPShare = JHHPatientAppEnv + "health_patri/v1/my_health_patri/share";
export const getUserHPUnShare = JHHPatientAppEnv + "health_patri/v1/my_health_patri/unshare";
export const  JHHTnCLink = JHHActualEnv + "jiohealthhub/tnc";
export const  JHHPPLink = JHHActualEnv + "jiohealthhub/pp";
export const  checksumSecretKey = "GZTHZAJNIOUZEKMLXXFJ";
export const  getAllGoalStatus = appIntegrationServiceVersion1 + "health-patri-service/api/activity/v1/get_goal_status";
export const  getAllActivityStatus =appIntegrationServiceVersion1 + "health-patri-service/api/activity/v1/get_all_activity_status";
export const  getAggregatedMetricData =appIntegrationServiceVersion1 + "data-service/aggregated_metric_data";
export const  promoCardData = env + "core-platform/knowlake/app_configuration/app_configuration.models.activity_tracker.ActivityTrackerAppConfig/64a3fdcee9e072e1578cf1f7/details/?json_forms_version=2";
export const  getSessionToken =
 JHHActualEnv+"appintegrationservice/v1/session-service/api/session";
export const  healthFeedWorkflowId = 1;
export const  validateSessionToken = "session-service/api/session/validate";
export const  setGoalUrl = appIntegrationServiceVersion1+"uaas-event-publisher-platform/api/event";
export const  getAllActivityUrl = appIntegrationServiceVersion1+"health-patri-service/api/activity/v1/get_all_activity";
export const  getActivityUrl = appIntegrationServiceVersion1+"health-patri-service/api/activity/v1/get_activity";
export const  raiseAddActivityUrl = appIntegrationServiceVersion1+"uaas-event-publisher-platform/api/event";
export const  validateSessionTokenPostLoggedIn = appIntegrationServiceVersion1+"post/session-service/api/session/validate";
export const getResourceId = BIFROST_DOMAIN_NAME + "/health-locker-golang-service/user_recent_tags"
export const viewReportURL = JHHMainEnv + "v1/static/view_report"
export const clusterName = 'cluster-jhh-ci-prod'
export const serviceName = 'webapp_health_patri'
export const collectorEndpoint = 'https://gepp-tempo.jio.ril.com/v1/traces'